import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import Button from '../../../components/actions/Button'
import { ModalContext } from '../../../contexts/ModalContext'
import ModalWrapper from '../../../wrappers/modalWrapper/ModalWrapper'

interface Props {}

const SmartChargingInstuctions: React.FC<Props> = () => {
	const { closeModal } = useContext(ModalContext)
	const { t } = useTranslation('pages_enodeInit')

	return (
		<ModalWrapper>
			<div className='text-text-dark dark:text-white'>
				<h1 style={{ marginTop: 0 }}>{t('smartChargingInstructions.alaotsikko')}</h1>
				<p>{t('smartChargingInstructions.info1')}</p>
				<p>{t('smartChargingInstructions.info2')}</p>
				<p>{t('smartChargingInstructions.info3')}</p>
				<p>{t('smartChargingInstructions.info4')}</p>
				<p>{t('smartChargingInstructions.alaotsikko2')}</p>
				{t('smartChargingInstructions.info5')}
				<p>
					{t('smartChargingInstructions.info6')} {t('smartChargingInstructions.info7')}
				</p>

				<Button className='w-full mb-4' onClick={() => closeModal()}>
					{t('takaisin', { ns: 'common' })}
				</Button>
			</div>
		</ModalWrapper>
	)
}
export default SmartChargingInstuctions
